/**
 * Khoa cache cua react-query, gom mot cho.
 *
 * Rai chuoi khoa trong tung man la cach hai man cung doc mot thu ma khong dung chung cache,
 * roi mot man cap nhat con man kia van hien so cu.
 */
export const khoa = {
  toi: ["toi"] as const,
  tongQuan: ["tong-quan"] as const,
  hangCho: ["hang-cho"] as const,
  /** Một bài theo id. Có `id` trong khoá, nếu không hai bài dùng chung một ô cache. */
  motBai: (id: string) => ["bai-viet", id] as const,
  health: ["health"] as const,
  baiHoc: ["bai-hoc"] as const,
  chiPhiTongQuan: ["chi-phi", "tong-quan"] as const,
  chiPhiTheoTacVu: ["chi-phi", "theo-tac-vu"] as const,
  chiPhiSoCai: ["chi-phi", "so-cai"] as const,
  caiDat: ["cai-dat"] as const,
  lich: ["lich"] as const,
  hoSoSite: ["ho-so-site"] as const,
  banGhiPrompt: ["ban-ghi-prompt"] as const,
  cauTrucPrompt: ["cau-truc-prompt"] as const,
  chanDung: ["chan-dung"] as const,
  nguon: ["nguon"] as const,
  nguonTinCay: ["nguon-tin-cay"] as const,
  ketNoi: ["ket-noi"] as const,
  sanPham: ["san-pham"] as const,
  /** Danh sach cua MOT site. Co `site` trong khoa, neu khong hai site dung chung mot o cache. */
  sanPhamCuaSite: (site: string) => ["san-pham", site] as const,
};
